import store from "store";

const getPermission = (id, right) => {
    const permissions = store.getState()?.user?.user?.permissions
    if(!permissions) return false;
    const hasPermission = permissions.find(item => item.id === id)?.permissions
    if (hasPermission === undefined) return false;
    return hasPermission[right]
}

export default getPermission;